import { useMutation } from "@tanstack/react-query";
import { updateChemistrySample } from "../../repositories/ChemistriesReportRepository";

export const useUpdateChemistrySampleMutation = () => {
  return useMutation({
    mutationFn: async ({
      chemistrySampleId,
      heatName,
      gradeId,
    }: {
      chemistrySampleId: number;
      heatName: string | null;
      gradeId: number | null;
    }) => {
      const resp = await updateChemistrySample(
        chemistrySampleId,
        heatName,
        gradeId,
      );
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};
